export { useContactsData, contactsPageQueryKeys } from './queries';
